/** App.tsx */
import React from "react";

export interface AppProps {
  children?: any;
}

const App = (props: AppProps) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default App;
